import { render, staticRenderFns } from "./ApprovalLockDialog.vue?vue&type=template&id=23e13e5c&scoped=true"
import script from "./ApprovalLockDialog.vue?vue&type=script&lang=js"
export * from "./ApprovalLockDialog.vue?vue&type=script&lang=js"
import style0 from "./ApprovalLockDialog.vue?vue&type=style&index=0&id=23e13e5c&prod&lang=scss&scoped=true"
import style1 from "./ApprovalLockDialog.vue?vue&type=style&index=1&id=23e13e5c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23e13e5c",
  null
  
)

export default component.exports